"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../styles/PickerStyle");
var ApiService_1 = require("../server/ApiService");
var AsyncPicker_1 = require("./AsyncPicker");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../gen-src/Localize");
var ErrorCodes_1 = require("../server/ErrorCodes");
var WarningIcon_1 = require("../img/WarningIcon");
var ErrorDivId = 'share-dialog-recipient-error';
exports.ErrorDivId = ErrorDivId;
var UserPicker = /** @class */ (function (_super) {
    __extends(UserPicker, _super);
    function UserPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            users: [],
        };
        _this.clearUsers = function () {
            _this.setState({ users: [], errorMessage: '' });
            _this.props.onUsersChanged([]);
        };
        _this.fetchUsers = function (searchTerm) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiService_1.ApiService.searchUser(searchTerm)
                        .then(function (getUsersResult) {
                        var result = getUsersResult.users;
                        // Remove the guest user
                        return result = result.filter(function (value) { return value.username !== UserPicker.GUEST_USERNAME; });
                    })];
            });
        }); };
        _this.recipientToChip = function (user) {
            if (user.verified) {
                return (React.createElement(widgets_1.Chip, { key: user.username, value: user.username, className: 'user-picker-chip user-picker-chip-normal', tooltip: user.displayName }, user.displayName));
            }
            else {
                var referenceToErrorDiv = user.errorMessage === _this.state.errorMessage ? ErrorDivId : undefined;
                return (React.createElement(widgets_1.ErrorChip, { key: user.username, value: user.username, className: 'user-picker-chip user-picker-chip-error', message: user.errorMessage || '', tooltip: user.errorMessage, "aria-describedby": referenceToErrorDiv, "aria-errormessage": referenceToErrorDiv }, user.displayName));
            }
        };
        _this.recipientToListItem = function (user) {
            var listItemTextToDisplay = !!user.displayName ? Localize_1.Messages.peoplePickerListItemFormat({
                FULL_NAME: user.displayName,
                USER_NAME: user.username
            })
                : user.username;
            return {
                content: listItemTextToDisplay,
                testId: 'user-listitem-' + user.username,
                value: user.username
            };
        };
        _this.recipientToStringId = function (user) { return user.username; };
        _this.addUserToList = function (user, targetIndex) {
            _this.setState(function (state) {
                var usersClone = state.users.slice();
                usersClone.splice(targetIndex, 0, user);
                return { users: usersClone, errorMessage: user.errorMessage, };
            }, function () {
                // Notify the shareDialog component about the change
                _this.props.onUsersChanged(_this.state.users.slice());
            });
        };
        _this.mapErrorCodeToMessage = function (code, userDisplayName) {
            switch (code) {
                case ErrorCodes_1.USER_INVALID_EMAIL_ADDRESS:
                    return Localize_1.Messages.peoplePickerErrorNoEmail({ NAME: userDisplayName });
                case ErrorCodes_1.SITE_USER_NOT_FOUND:
                default:
                    return Localize_1.Messages.peoplePickerErrorNoUser({ NAME: userDisplayName });
            }
        };
        _this.onValueAdd = function (user, targetIndex) {
            // Add the chip only if we are under the maximum number of users
            if (_this.state.users.length < UserPicker.MAX_NUM_RECIPIENTS) {
                ApiService_1.ApiService.verifyUser(user.id).then(function () {
                    // Add the newley selected verified chip to this.state.users
                    user.verified = true;
                    _this.addUserToList(user, targetIndex);
                }, function (error) {
                    // Add the newly selected error chip to this.state.users
                    user.verified = false;
                    user.errorMessage = _this.mapErrorCodeToMessage(error, user.displayName);
                    _this.addUserToList(user, targetIndex);
                });
            }
        };
        // Invoked when chips are rearranged or deleted.
        _this.onValuesChange = function (users) {
            _this.setState({
                users: users,
                errorMessage: '',
            }, function () {
                _this.props.onUsersChanged(_this.state.users.slice());
            });
        };
        return _this;
    }
    UserPicker.prototype.componentDidMount = function () {
        this.props.saveClearUsers(this.clearUsers);
    };
    UserPicker.prototype.render = function () {
        return (React.createElement("div", null,
            this.chipPicker(),
            React.createElement("div", { style: styles.errorDiv, id: ErrorDivId, "aria-live": 'polite' },
                this.state.errorMessage &&
                    React.createElement(WarningIcon_1.WarningIcon, { style: styles.icon, "aria-hidden": true }),
                this.state.errorMessage)));
    };
    UserPicker.prototype.chipPicker = function () {
        return React.createElement(AsyncPicker_1.AsyncPicker, { label: Localize_1.Messages.peoplePickerLabel(), placeholder: Localize_1.Messages.peoplePickerPlaceholder(), recipients: this.state.users, fetchRecipientsCallback: this.fetchUsers, onRecipientAdd: this.onValueAdd, onRecipientsChange: this.onValuesChange, recipientToListItem: this.recipientToListItem, recipientToStringId: this.recipientToStringId, recipientToChip: this.recipientToChip, onFilterChanged: this.props.onTextChanged, debounceTimeout: UserPicker.DEBOUNCE_TIMEOUT_MS });
    };
    UserPicker.MAX_NUM_RECIPIENTS = 50;
    UserPicker.DEBOUNCE_TIMEOUT_MS = 200;
    UserPicker.GUEST_USERNAME = 'guest';
    return UserPicker;
}(React.PureComponent));
exports.UserPicker = UserPicker;
//# sourceMappingURL=UserPicker.js.map